import * as PIXI from "pixi.js";
import {drawRoundedRect} from "../../utils/graphics";
import {Assets} from "pixi.js";
import TWEEN from "@tweenjs/tween.js";
import {gameData, ticker} from "../../utils/pixiApp";


const sizes = {
    web: {
        nodalWidth: 380,
        modalHeight: 502,
        padding: 16,
        contentWidth: 348
    }
}

const titleStyle = new PIXI.TextStyle({
    fontSize: 16,
    fontWeight: 600,
    letterSpacing: .15,
    fill: '#000',
    lineHeight: 24,
    fontFamily: "Montserrat",
    align: "center",
})

const textStyle = new PIXI.TextStyle({
    wordWrap: true,
    "wordWrapWidth": 348,
    fontSize: 16,
    color: '#414241',
    fontFamily: "Montserrat",
    lineHeight: 22.4
})


export class QuestionsModalComponent extends PIXI.Container {
    constructor() {
        super();

        this.statePage = 1;
        this.bg = new PIXI.Graphics()
        drawRoundedRect(this.bg, 0, 0, sizes.web.nodalWidth, sizes.web.modalHeight, 24);
        this.bg.fill('#FFFFFF')
        this.bg.pivot.set(.5,.5)
        this.bg.position.set( - sizes.web.nodalWidth / 2, - sizes.web.modalHeight / 2)

        this.addChild(this.bg)

        this.title1 = new PIXI.Text({ text: 'Правила игры', style: titleStyle });
        this.title1.anchor.set(.5)
        this.title1.position.set(this.bg.width / 2, sizes.web.padding + this.title1.height / 2)

        this.title2 = new PIXI.Text({ text: 'Таблица выплат \n для указанной ставки', style: titleStyle });
        this.title2.anchor.set(.5)
        this.title2.position.set(this.bg.width / 2, sizes.web.padding + this.title2.height / 2)
        this.title2.alpha = 0

        this.closeBtn = new PIXI.Sprite(Assets.get('close'))
        this.closeBtn.setSize(24,24)
        this.closeBtn.anchor.set(.5)
        this.closeBtn.position.set(this.bg.width - 28, 28)
        this.closeBtn.eventMode = 'static'
        this.closeBtn.cursor = 'pointer'

        this.line = new PIXI.Graphics()
        this.line.moveTo(0, 0);
        this.line.lineTo(sizes.web.contentWidth, 0);
        this.line.stroke({ width: 1, color: ('rgba(0, 0, 0, .1)') });
        this.line.pivot.set(.5, .5)
        this.line.position.set(sizes.web.padding, 60)

        this.content1 = new PIXI.Container()
        this.content1.zIndex = 2
        this.content2 = new PIXI.Container()
        const bet = new Bet(this.position, this.bg.width)
        this.content2.addChild(bet)
        this.content2.alpha = 0;
        this.content2.eventMode = 'none'

        this.text = new PIXI.Text({
            text: 'Стирайте защитное покрытие на игровых полях. Вы выигрываете,' +
                ' если в трех игровых полях под защитным слоем находятся одинаковые числа. Выигрыш равен этому числу. ' +
                '\n' +
                '\n' +
                'Возможные выигрыши указаны в таблице',
            style: textStyle });

        this.content1Btn = new PIXI.Sprite(Assets.get('tableLink'))
        this.content1Btn.setSize(201,44)
        this.content1Btn.position.set(16, 291)
        this.content1Btn.eventMode = 'static';
        this.content1Btn.cursor = 'pointer'


        this.text.position.set(16, 80)

        this.content1.addChild(this.text, this.content1Btn)

        this.arrow = new PIXI.Sprite(Assets.get('arrow'))
        this.arrow.scale.set(.5)
        this.arrow.anchor.set(.5,.5)
        this.arrow.position.set(348, this.bg.height - 32)
        this.arrow.eventMode = 'static'
        this.arrow.cursor = 'pointer'

        this.arrowLeft = new PIXI.Sprite(Assets.get('arrowInactive'))
        this.arrowLeft.anchor.set(.5,.5)
        this.arrowLeft.scale.set(.5)
        this.arrowLeft.angle = -180
        this.arrowLeft.position.set(32, this.bg.height - 31)
        this.arrowLeft.cursor = 'pointer'

        this.dot1 = new PIXI.Sprite(PIXI.Texture.from('dot'))
        this.dot2 = new PIXI.Sprite(PIXI.Texture.from('dotInactive'))
        this.dot1.setSize(6,6)
        this.dot1.position.set(-8, 0)
        this.dot2.setSize(6,6)
        this.dot2.position.set(2, 0)
        this.dotContainer = new PIXI.Container()
        this.dotContainer.addChild(this.dot1, this.dot2)
        this.dotContainer.position.set(this.bg.width / 2, this.bg.height - 38)


        this.bg.addChild(this.title1, this.title2, this.closeBtn, this.line, this.content1, this.content2, this.arrowLeft, this.arrow, this.dotContainer)

        this.closeBtn.on('pointerover', this.onPointerOver.bind(this))
        this.closeBtn.on('pointerout', this.onPointerOut.bind(this))
        this.closeBtn.on('pointerdown', this.onClose.bind(this))

        this.content1Btn.on('pointerdown', this.onChangeStateToChips.bind(this))
        this.arrow.on('pointerdown', this.onChangeStateToChips.bind(this))
        this.arrowLeft.on('pointerdown', this.onChangeStateToHome.bind(this))

        this.TWEEN = TWEEN;
        ticker.add(() => this.TWEEN.update())
    }

    onPointerOver(e) {
        this.tweenScaleAnimate = new this.TWEEN.Tween({scale: .5})
            .to({scale: .8}, 500)
            .easing(TWEEN.Easing.Elastic.Out)
            .onUpdate((obj) => {
                this.closeBtn.scale.set(obj.scale, obj.scale)
            })

        this.tweenScaleAnimate.start()
    }

    onPointerOut() {
        this.tweenScaleAnimate = new this.TWEEN.Tween({scale: .8})
            .to({scale: .5}, 500)
            .easing(TWEEN.Easing.Elastic.Out)
            .onUpdate((obj) => {
                this.closeBtn.scale.set(obj.scale, obj.scale)
            })

        this.tweenScaleAnimate.start()
    }

    onClose() {
        this.emit('IS_OPEN_EVENT', false)
    }

    onChangeStateToChips() {
        this.statePage = 2
        this.dot1.texture = PIXI.Texture.from('dotInactive')
        this.dot2.texture = PIXI.Texture.from('dot')

        this.arrow.texture = Assets.get('arrowInactive')
        this.arrowLeft.texture = Assets.get('arrow')
        this.content1.eventMode = 'none'
        this.content2.eventMode = 'static'
        this.arrowLeft.eventMode = 'static'
        this.arrow.eventMode = 'none'

        const tweenChangeAnimate = new this.TWEEN.Tween({alpha: 1})
            .to({alpha: 0}, 300)
            .onUpdate((obj) => {
                this.content1.alpha = obj.alpha
                this.title1.alpha = obj.alpha
                this.line.alpha = obj.alpha
            }).onComplete(() => {
                this.line.position.y = 84
            })

        const tweenChangeAnimate2 = new this.TWEEN.Tween({alpha: 0})
            .to({alpha: 1}, 300)
            .onUpdate((obj) => {
                this.content2.alpha = obj.alpha
                this.title2.alpha = obj.alpha
                this.line.alpha = obj.alpha
            })

        tweenChangeAnimate.chain(tweenChangeAnimate2)

        tweenChangeAnimate.start()
    }

    onChangeStateToHome() {
        this.statePage = 2
        this.dot2.texture = PIXI.Texture.from('dotInactive')
        this.dot1.texture = PIXI.Texture.from('dot')

        this.arrow.texture = Assets.get('arrow')
        this.arrowLeft.texture = Assets.get('arrowInactive')
        this.content1.eventMode = 'static'
        this.arrow.eventMode = 'static'
        this.content2.eventMode = 'none'
        this.arrowLeft.eventMode = 'none'

        const tweenChangeAnimate = new this.TWEEN.Tween({alpha: 1})
            .to({alpha: 0}, 300)
            .onUpdate((obj) => {
                this.content2.alpha = obj.alpha
                this.title2.alpha = obj.alpha
                this.line.alpha = obj.alpha
            }).onComplete(() => {
                this.line.position.y = 60
            })

        const tweenChangeAnimate2 = new this.TWEEN.Tween({alpha: 0})
            .to({alpha: 1}, 300)
            .onUpdate((obj) => {
                this.title1.alpha = obj.alpha
                this.line.alpha = obj.alpha
                this.content1.alpha = obj.alpha
            })

        tweenChangeAnimate.chain(tweenChangeAnimate2)

        tweenChangeAnimate.start()
    }
}

const headerStyle = new PIXI.TextStyle({
    fontSize: 10,
    fontFamily: "MontserratBold, sans-serif",
    fill: '#ffffff',
})
const betStyle = new PIXI.TextStyle({
    fontSize: 14,
    textTransform: 'uppercase',
    fontFamily: "MontserratBold, sans-serif",
    fontWeight: 'bold',
    fill: '#ffffff',
})
const chipTextStyle = new PIXI.TextStyle({
    fontSize: 28,
    textTransform: 'uppercase',
    fontFamily: "Montserrat, sans-serif",
    fontWeight: '600',
    fill: '#f24822',
})

class Bet extends PIXI.Container {
    constructor(parentPosition, parentWidth) {
        super();
        const data = gameData.getGameData()
        this.bets = data.bets;
        this.chips = []
        this.betsKeys = [...this.bets.keys()]
        this.activeBet = 0;
        this.position.set(parentPosition.x,114)
        this.bg = new PIXI.Graphics()
        this.bg.roundRect(0,0, 128,46,22)
        this.bg.fill('#0f0f0f')
        this.bg.position.set(this.position.x + (parentWidth / 2) - 64, 0)
        this.bg.pivot.set(.5,.5)

        this.leftBtn = new PIXI.Sprite(Assets.get('minusDisabled'))
        this.leftBtn.anchor.set(.5,.5)
        this.leftBtn.setSize(24,24)
        this.leftBtn.position.set(22, this.bg.position.y + this.bg.height / 2)
        this.leftBtn.cursor = 'pointer'
        this.rightBtn = new PIXI.Sprite(Assets.get('plusActive'))
        this.rightBtn.setSize(24,24)
        this.rightBtn.anchor.set(.5,.5)
        this.rightBtn.position.set(this.bg.width - 22, this.bg.height / 2)
        this.rightBtn.eventMode = 'static'
        this.rightBtn.cursor = 'pointer'

        this.textHeader = new PIXI.Text({ text: 'Ставка:', style: headerStyle });
        this.textHeader.position.set(this.bg.width / 2, 11)
        this.textHeader.anchor.set(.5,.5)
        this.textBet = new PIXI.Text({ text: this.betsKeys[this.activeBet], style: betStyle });
        this.textBet.position.set(this.bg.width / 2, 30)
        this.textBet.anchor.set(.5,.5)

        this.bg.addChild(this.leftBtn, this.rightBtn, this.textHeader, this.textBet)

        this.addChild(this.bg)

        for (let i = 0; i < 9; i++) {
            const chip = new PIXI.Sprite(Assets.get('chip'))
            chip.anchor.set(.5)
            chip.setSize(96,40)
            const posX = (86 + 102 * (i % 3));
            const posY = (96 + 56 * Math.floor(i / 3))
            chip.position.set(posX, posY);
            const textContent =  this.bets.get(this.betsKeys[this.activeBet])[i]
            const chipText = new PIXI.Text({ text: textContent, style: chipTextStyle });
            chipText.position.set(0, 0)
            chipText.anchor.set(.5)
            chip.addChild(chipText)
            this.chips.push(chip)
            this.addChild(chip);
        }


        this.rightBtn.on('pointerdown', () => this.pointerDown('top'))
        this.leftBtn.on('pointerdown', () => this.pointerDown('bottom'))

    }

    pointerDown(dir) {
        if(dir === 'top') {
            this.activeBet += 1;
            if(this.betsKeys.length - 1 === this.activeBet) {
                this.rightBtn.eventMode = 'passive'
                this.rightBtn.texture = Assets.get('plusDisabled')
            } if(this.leftBtn.eventMode === 'passive') {
                this.leftBtn.eventMode = 'static'
                this.leftBtn.texture = Assets.get('minusActive')
            }
        } else {
            this.activeBet -= 1
            if(this.activeBet === 0) {
                this.leftBtn.eventMode = 'passive'
                this.leftBtn.texture = Assets.get('minusDisabled')
            } if(this.rightBtn.eventMode === 'passive') {
                this.rightBtn.eventMode = 'static'
                this.rightBtn.texture = Assets.get('plusActive')
            }
        }

        this.textBet.text = this.betsKeys[this.activeBet]
        this.chips.forEach((item, idx) => {
            item.children[0].text = this.bets.get(this.betsKeys[this.activeBet])[idx]
        })
    }

}